export const constant = {
	selector: {
		stickyBox: '.sticky',
		stickyBlocks: '.js-sticky-block',
		isShadow: '.is-shadow',
	},
}
